@if (showHeader) {
  <ui-message-custom>
    {{ 'orderProcess.payment.zeroPayment.note' | translate }}
  </ui-message-custom>
  <div class="d-flex mt-5 mb-4 flex-column align-items-start flex-lg-row align-items-lg-end mt-2">
    <h4 class="me-2 mb-0">{{ 'orderProcess.payment.contactForm.title' | translate }}</h4>
    <div class="text-primary cursor-pointer font-md d-none d-sm-block"
         [translate]="'orderProcess.payment.whyDoAskInfo.question'"
         ngbTooltip="{{'orderProcess.payment.whyDoAskInfo.answer' | translate}}">
    </div>
  </div>
}

<payment-contact-info-b
  [userInfo]="contactInfo"
  [countryCode]="countryCode"
  [personType]="personType"
  [bakeryId]="bakeryId"
  [askForReferenceField]="personType === PAYMENT_PERSON_TYPES.COMPANY"
  [useCompanySearcher]="personType === PAYMENT_PERSON_TYPES.COMPANY"
  (onCompanySelected)="onCompanySelected.emit($event)"
  (onInfoUpdated)="onInfoUpdated($event)"
  (onValidUpdated)="isContactInfoValid = $event"
></payment-contact-info-b>

<button class="btn btn-pink payment-confirm-btn my-4"
        [disabled]="!isContactInfoValid"
        (click)="submit()">
  {{ 'orderProcess.payment.confirmOrder' | translate }}
</button>

<terms-and-conditions
  (onTermsClick)="onTermsClick.emit()"
></terms-and-conditions>
